import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=60bac1c0&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports